import landingBanner from "assets/images/landing/landingpagebanner.svg";
import { useTheme } from "@mui/material/styles";

export const useStyles = () => {
  const theme = useTheme();
  return {
    formBg: {
      backgroundColor: "white",
      border: "1px solid  #2196F333",
      borderRadius: "8px",
      boxShadow: "0px 0px 20px 8px #2196F333",
      positions: "absolute",
    },
    form: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "center",
      width: "100%",
    },
    loginBtn: {
      marginTop: "2.25rem",
    },
    textDecorationNone: {
      textDecoration: "none",
    },
    bannerContainer: {
      background: `url(${landingBanner}) no-repeat center/cover`,
      height: { xs: "220px" },
      display: "flex",
      paddingTop: 5,
      justifyContent: "center",
      borderRadius: "12px",
    },
    bannerImageContainer: {
      display: "flex",
      justifyContent: "center",
      alignItems: "flex-start",
    },
    bannerImage: {
      maxWidth: "250px",
      height: "auto",
    },
    bannerImageResponsive: {
      maxWidth: "220px",
      height: "auto",
    },
    bannerTextContainer: {
      display: "flex",
      justifyContent: "center",
    },
    bannerText: {
      marginTop: "2rem",
      color: "white",
      fontSize: { xs: "1rem", sm: "1.5rem", lg: "2rem", xl: "2.5rem" },
      fontWeight: 700,
      textAlign: { xs: "center", sm: "left" },
    },
    aboutBox: {
      paddingX: { xs: 2, md: 13 },
    },
    aboutText: {
      letterSpacing: "4%",
      lineHeight: "32px",
      textAlign: { xs: "center", md: "left" },
    },
    aboutImage: {
      maxWidth: "450px",
      width: "100%",
      borderRadius: "20px",
    },
    gridItem: {
      display: "flex",
      justifyContent: "flex-start",
      alignItems: "center",
      backgroundColor: "#F0FCFF",
      // paddingTop: { md: 4 },
      paddingBottom: { md: 12 },
    },
    loginBanner: {
      width: "100%",
      maxWidth: "600px",
      height: "auto",
    },
    authCardWrapper: {
      position: { md: "absolute", xs: "unset" },
      top: 10,
      right: 0,
      paddingY: 0.5,
    },
    tabs: {
      ".MuiTabs-flexContainer": {
        borderBottom: "none",
      },
    },
    tabLabel: {
      color: "#0389B5",
      fontWeight: 900,
    },
    divider: {
      marginBottom: "0.9rem",
    },
    registerLink: {
      color: theme.palette.secondary.main,
    },
    infoButton: {
      borderColor: "#3E3F40",
      color: "#3E3F40",
      padding: "10px 20px",
    },
    loginImage: {
      display: "flex",
      justifyContent: "center",
      alignItems: "start",
    },
  };
};
